export class SetPendingAddressPermissionsRequestDTO {
  constructor() {
    this.code = null;
    this.activation_id = null;
    this.address = null;
    this.permissions = null;
  }
}